import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(
  (theme) => ({
    subtitle: {
      marginBottom: theme.spacing(1),
    },

    passwordNotes: {
      display: 'flex',
      justifyContent: 'space-between',
    },

    linkButtons: {
      marginLeft: theme.spacing(0.5),
      marginTop: theme.spacing(5),

      cursor: 'pointer',
      textDecoration: 'underline',
      color: theme.palette.primary.main,
    },

    captchaContainer: {
      alignSelf: 'flex-start',
      margin: theme.spacing(1, 0),
    },

    captchaPolicy: {
      margin: theme.spacing(2, 0, 0, 0.5),
      fontSize: 10,
    },
  }),
  {
    name: 'SignInForm',
  },
);
